module.exports = __webpack_public_path__ + "static/media/kerry.1c3870bb.png";